import { useEffect, useMemo } from "react";

import { useDispatch } from "react-redux";

import { MUI_DRAWER_IS_OPEN } from "@src/multiCustodian/reducers/commonActions";

interface UseDrawerStateProps {
  isDrawerOpen: boolean;
  width?: number | string;
}

const useDrawerState = ({
  isDrawerOpen,
  width = 600,
}: UseDrawerStateProps): void => {
  const dispatch = useDispatch();

  const numericWidth = useMemo(
    () =>
      typeof width === "string" && width.endsWith("px")
        ? parseInt(width, 10)
        : typeof width === "number"
        ? width
        : 600,
    [width]
  );

  useEffect(() => {
    dispatch({
      type: MUI_DRAWER_IS_OPEN,
      payload: {
        isOpen: isDrawerOpen,
        width: isDrawerOpen ? numericWidth : undefined,
      },
    });
  }, [isDrawerOpen, numericWidth, dispatch]);
};

export default useDrawerState;
